import {Tag} from '@carbon/react';
import './filter-tags.scss';

type Props = {
    values: string[];
    onRemove: (value: string) => void;
    itemToString?: (item: string) => string;
    maxDisplay?: number;
    showPrimaryIndicator?: boolean;
};

export default function FilterTags(props: Props) {
    const {values, onRemove, itemToString, maxDisplay, showPrimaryIndicator = false} = props;

    if (values.length === 0) return null;

    const shouldLimit = maxDisplay && values.length > maxDisplay;
    const displayValues = shouldLimit ? values.slice(0, maxDisplay) : values;
    const remainingCount = shouldLimit ? values.length - maxDisplay : 0;

    return (
        <div className="filter-tags">
            {displayValues.map((value, index) => {
                const isPrimary = showPrimaryIndicator && index === 0;

                if (isPrimary) {
                    // Primary tag: blue background, NO close button, NO info icon
                    return (
                        <div key={value} className="filter-tag-wrapper">
                            <Tag
                                type="blue"
                                className="filter-tag filter-tag-primary"
                            >
                                {itemToString ? itemToString(value) : value}
                            </Tag>
                        </div>
                    );
                }

                // Secondary tags: gray background with close button, NO info icon
                return (
                    <div key={value} className="filter-tag-wrapper">
                        <Tag
                            type="gray"
                            filter
                            onClose={() => onRemove(value)}
                            className="filter-tag"
                        >
                            {itemToString ? itemToString(value) : value}
                        </Tag>
                    </div>
                );
            })}
            {remainingCount > 0 && (
                <Tag type="gray" className="filter-tag-count">
                    +{remainingCount} more
                </Tag>
            )}
        </div>
    );
}
